import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryExamUpdateAction from './veterinaryExamUpdate.action.json' with { type: 'json' }
import { veterinaryExamObject } from '../veterinaryExamObject'

const veterinaryExamUpdateDefinition = defineAction({
  ...veterinaryExamUpdateAction,

  input: veterinaryExamObject.partial().required({ id: true }),
  output: z.object({}),
})

export default veterinaryExamUpdateDefinition
